<template>
    <!-- 支持自定义右上角按钮 内容 底部按钮等 -->
    <el-dialog :custom-class="'lx-dialog'" :width="width" :top="top" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" :text-close="closeText" :text-confirm="confirmText" :show-close="false" append-to-body @close="onClose">
        <!-- 头部 -->
        <div slot="title" class="lx-dialog-header lx-flex-row">
            <!-- 标题 -->
            <div class="title fz20 fwBold lx-flex-grow-1">
                <!-- <span>{{ title }}</span> -->
                <slot name="title" />
            </div>
            <!-- 右上角图标 -->
            <div class="topRightIcon lx-flex-shrink-0">
                <i v-if="!isCustomeIcon" class="lx-icon el-icon-close lx-pointer" @click="onClose" />
                <slot v-else name="topRightIcon" />
            </div>
        </div>
        <!-- 主体内容 -->
        <div class="lx-dialog-main">
            <slot />
        </div>
        <div slot="footer" class="lx-dialog-footer">
            <!-- 使用默认底部 -->
            <div v-if="!isCustomeFooter" class="lx-footer-wrap-default">
                <slot name="custome-button" />
                <el-button size="small" @click="onClose">{{ closeText }}</el-button>
                <el-button type="primary" size="small" @click="onConfirm()">{{
          confirmText
        }}</el-button>
            </div>
            <!-- 使用自定义底部 -->
            <div v-else class="lx-footer-wrap-custome">
                <slot name="custome-footer" />
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "LxDialog",
    props: {
        title: {
            // 标题
            type: String,
            default: "",
        },
        width: {
            // dialog宽度
            type: String,
            default: "550px",
        },
        isVisibleDialog: {
            // 是否显示dialog
            type: Boolean,
            default: false,
        },
        isCustomeFooter: {
            // 是否自定义dialog底部
            type: Boolean,
            default: false,
        },
        closeText: {
            // 自定义取消按钮文字
            type: String,
            default: "取 消",
        },
        confirmText: {
            // 自定义确定按钮文字
            type: String,
            default: "确 定",
        },
        isCustomeIcon: {
            // 自定义右上角图标
            type: Boolean,
            default: false,
        },
        top: {
            type: String,
            default: "15vh",
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    watch: {
        isVisibleDialog() {
            this.visible = this.isVisibleDialog;
        },
    },
    methods: {
        onClose() {
            this.$emit("close");
            // this.$emit('update:isVisibleDialog', false)
        },
        onConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>
<style lang="less" scoped>
.lx-dialog-header {
    height: 70px;
    line-height: 70px;
    font-size: 20px;
    overflow: hidden;
    border-radius: 2px 2px 0 0;
    border-bottom: 1px solid #e6ebf5;
    .title {
        padding: 0 30px;
    }
    .lx-icon {
        padding: 13px 20px;
        font-size: 22px;
        font-weight: bold;
        color: #2e2f39;
    }
}
.lx-dialog-main,
.lx-dialog-footer {
    padding-left: 25px;
    padding-right: 25px;
}
.lx-dialog-footer {
    text-align: center;
}
/deep/ .el-dialog__header {
    padding: 0;
}
/deep/ .el-dialog__footer {
    border-top: none;
    padding-top: 0;
}
</style>
